import { render, staticRenderFns } from "./DrugATC.vue?vue&type=template&id=292cb4a3&"
import script from "./DrugATC.vue?vue&type=script&lang=js&"
export * from "./DrugATC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports